import React from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa';
import { useFileActions } from '../../../../hooks/useFileActions';

export const StarNameCell = ({
  id,
  nom,
  lu,
  favori,
}: {
  id: string;
  nom: string;
  lu: boolean;
  favori: boolean;
}) => {
  const { toggleFavorite, isLoading } = useFileActions();

  const handleStarClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleFavorite(id, favori);
  };

  return (
    <div className="flex h-10 cursor-pointer items-center pl-3 font-medium">
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex h-full cursor-default items-center"
      >
        <button
          onClick={handleStarClick}
          disabled={isLoading}
          className={`relative cursor-default before:absolute before:left-1/2 before:top-1/2 before:z-10 before:mr-5 before:h-10 before:w-10 before:-translate-x-1/2 before:-translate-y-1/2 before:cursor-pointer before:rounded-full hover:before:bg-[#eaeaed] dark:hover:before:bg-[#545454] ${isLoading ? 'opacity-50' : ''}`}
        >
          {favori ? (
            <FaStar className="relative z-50 cursor-pointer text-lg text-[orange] opacity-100" />
          ) : (
            <FaRegStar className="action-star relative z-50 cursor-pointer text-lg opacity-40" />
          )}
        </button>
      </div>
      <div
        className={`ml-5 w-[calc(100%-45px)] ${lu ? 'font-normal opacity-90' : 'font-semibold'}`}
      >
        <p
          className="truncate text-sm"
          data-tooltip-content={nom}
          data-tooltip-id="tooltip"
          data-tooltip-place="top-start"
          data-tooltip-delay-show={100}
          data-tooltip-offset={5}
        >
          {nom}
        </p>
      </div>
    </div>
  );
};
